import { FacetFilterMenu } from '@/components/FacetFilterMenu'
import type { FacetGroup } from '@/components/FacetFilterMenu'
import { INVOICE_STATUS_LABELS, INVOICE_STATUS_VALUES } from '@/lib/invoice'
import { STATUS_GROUP_LABEL, STATUS_PARAM, countInvoiceMenuFacets, toggleInvoiceStatus } from '@/lib/invoiceFilters'
import type { InvoiceFacetFilters } from '@/lib/invoiceFilters'

interface InvoiceFilterMenuProps {
  filters: InvoiceFacetFilters
  onChange: (next: InvoiceFacetFilters) => void
}

export function InvoiceFilterMenu({ filters, onChange }: InvoiceFilterMenuProps): React.ReactElement {
  const groups: FacetGroup[] = [
    {
      key: STATUS_PARAM,
      label: STATUS_GROUP_LABEL,
      options: INVOICE_STATUS_VALUES.map((status) => ({
        key: status,
        label: INVOICE_STATUS_LABELS[status],
        isChecked: filters.status === status,
        onToggle: () => onChange(toggleInvoiceStatus(filters, status))
      }))
    }
  ]

  return (
    <FacetFilterMenu
      groups={groups}
      activeCount={countInvoiceMenuFacets(filters)}
    />
  )
}
